import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterSituacaoCadastroFamilia = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/situacao-familia/${cpf}`;
  const headers = getHeader();
  let response;

  try {
    if (cpf) {
      response = await http.get(url, { headers });
    }
    return responseHandler(response);
  } catch (error) {
    console.log("precadastroAPI: erro capturado: ", error);
    console.log("precadastroAPI: error.response: ", (error as any).response);
    return responseHandler(error);
  }
};

export const obterDadosBasicosPreFamilia = async (cpf: string) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/${cpf}`;
  const headers = getHeader();
  const response = await http.post(url, null, { headers });
  return responseHandler(response);
};

export const obterEnderecoPreFamilia = async (idPreFamilia: number) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/endereco/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const salvarEnderecoPreFamilia = async (idPreFamilia: number, dadosEndereco: any) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/endereco/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.post(url, dadosEndereco, { headers });
  return responseHandler(response);
};

export const obterContatoPreFamilia = async (idPreFamilia: number) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/contato/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const salvarContatoPreFamilia = async (idPreFamilia: number, dadosContato: any) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/contato/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.post(url, dadosContato, { headers });
  return responseHandler(response);
};

export const enviarPreCadastroCaixa = async (idPreFamilia: number , cpf: string, ip: string) => {
  const url = env.urlApi + `/transacional-api/v1/caixa/${idPreFamilia}`;
  const headers = getHeader({cpfUsuarioLogado: cpf, ipUsuarioLogado:ip});
  const response = await http.put(url, null, {headers})
  return responseHandler(response);
};

export const obterDadosIntegrantePreFamilia = async (idPreFamilia: number, idIntegrante: number) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/prefamilia/${idPreFamilia}/integrante/${idIntegrante}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const inserirIntegrantePreFamilia = async (idPreFamilia: number, dadosIntegrante: any) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/prefamilia/${idPreFamilia}/integrante`;
  const headers = getHeader();
  const response = await http.post(url, dadosIntegrante, { headers });
  return responseHandler(response);
};

export const alterarIntegrantePreFamilia = async (idPreFamilia: number, dadosIntegrante: any) => {
  const url =
    env.urlApi + `/transacional-api/v1/precadastro/prefamilia/${idPreFamilia}/integrante/${dadosIntegrante.id}`;
  const headers = getHeader();
  const response = await http.put(url, dadosIntegrante, { headers });
  return responseHandler(response);
};

export const excluirIntegrantePreFamilia = async (idPreFamilia: number, idIntegrante: number) => {
  const url =
    env.urlApi + `/transacional-api/v1/precadastro/prefamilia/${idPreFamilia}/integrante/${idIntegrante}`;
  const headers = getHeader();
  const response = await http.delete(url, { headers });
  return responseHandler(response);
};

export const obterOrgaosEmissores = async () => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/orgaos-emissores`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const consultarDadosPreCadastro = async (idPreFamilia: number) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const consultarIntegrantePreCadastro = async (idIntegrante: number) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/integrante/${idIntegrante}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const verificarPossiblidadeRemocaoPreFamiliaCadUnico = async (cpf: string, idPreFamilia: string) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/${cpf}/permite-excluir-pre-familia/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterDadosGeraisPreFamiliaAptaExcusaoPeloCPFIntegranteFamiliar = async (cpf: string, idPreFamilia: string) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/${cpf}/integrante/dados-gerais-exclusao-pre-familia/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const excluirPreCadastroFamilia = async (cpf: string, idPreFamilia: string) => {
  const url = env.urlApi + `/transacional-api/v1/precadastro/${cpf}/exclusao-pre-familia/${idPreFamilia}`;
  const headers = getHeader();
  const response = await http.delete(url, { headers });
  return responseHandler(response);
};

export const verificarElegibilidadeIntegrante = async (cpf: string, cpfUsuarioLogado: string, dataNascimento: any) => {
  let url = env.urlApi + `/transacional-api/v1/precadastro/${cpf}/verificar-elegibilidade-integrante/${cpfUsuarioLogado}?`;
  url += `dataNascimento=${dataNascimento}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
